
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"annee"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id_utilisateur"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPaimentAf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"annee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"annee"}}},{"kind":"Argument","name":{"kind":"Name","value":"id_utilisateur"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id_utilisateur"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"num_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"num_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id_editeur_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id_editeur_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"periode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editeur"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"revenus_credits_mois"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"solde"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"somme"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"etat_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"etat_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_modification_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_modification_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pdf_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pdf_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":533}};
    doc.loc.source = {"body":"query ($annee: String, $id_utilisateur: Int) {\n    getPaimentAf(annee: $annee, id_utilisateur: $id_utilisateur){\n        num_perf\n        num_coreg\n        id_editeur_perf\n        id_editeur_coreg\n        periode\n        editeur\n        revenus_credits_mois\n        solde\n        somme\n        etat_perf\n        etat_coreg\n        message_perf\n        message_coreg\n        date_perf\n        date_coreg\n        date_modification_perf\n        date_modification_coreg\n        pdf_perf\n        pdf_coreg\n        flag\n    }\n           \n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
